//import '@mdi/font/scss/materialdesignicons.scss';
import './main.scss';
import Vue from 'vue';
import App from './App';
import router from './router';
import {publicRoutes} from '@/utils/misc';
import {
  Navbar,
  Sidebar,
  Menu,
  Icon,
  Dropdown,
  Field,
  Switch,
  Button,
  Loading,
  Image,
  Input,
  Toast,
  Numberinput,
  Timepicker,
  Datepicker,
  Tag,
  Modal,
  Radio,
  Notification,
  Snackbar,
  Tabs,
  Select,
  Steps,
  Taginput,
  //Carousel,
  //Datetimepicker,
  Checkbox,
} from 'buefy';

Vue.config.productionTip = false;

Vue.use(Navbar);
Vue.use(Sidebar);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(Dropdown);
Vue.use(Field);
Vue.use(Switch);
Vue.use(Button);
Vue.use(Loading);
Vue.use(Image);
Vue.use(Input);
Vue.use(Toast);
Vue.use(Numberinput);
Vue.use(Datepicker);
Vue.use(Timepicker);
Vue.use(Tag);
Vue.use(Modal);
Vue.use(Radio);
Vue.use(Notification);
Vue.use(Snackbar);
Vue.use(Tabs);
Vue.use(Select);
Vue.use(Steps);
Vue.use(Taginput);
//Vue.use(Carousel);
//Vue.use(Datetimepicker)
Vue.use(Checkbox)

router.beforeEach((to, from, next) => {
  // add trailing slashes
  let publicRoutesWithVariants = publicRoutes.reduce((prev, current) => {
    prev.push(current, current + '/');
    return prev;
  }, []);

  if (publicRoutesWithVariants.includes(to.path) || to.name === 'upsellSlug') return next();

  let user = JSON.parse(localStorage.getItem('user'));
  let isAdmin = user && 'admin_id' in user;
  let isModulesOnly = process.env.VUE_APP_IS_MODULES_ONLY;

  if (!user) {
    return next({path: '/login', query: to.query});
  }

  if (to.path.slice(0,6) === '/admin' && !isAdmin) {
    return next('/login');
  }

  if (to.path === '/' && isAdmin) {
    return next('/admin');
  }

  if (to.path === '/' && isModulesOnly) {
    return next('/modules');
  }

  next();
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
